import { FiExternalLink } from 'react-icons/fi';

import type { ApiException } from '@/common/error';
import { useMeQuery } from '@/store/people/people.store';

import s from '../subscription.module.scss';
import { useBillingPortal } from '../useBillingPortal';

const errorMessage = (error: unknown) =>
  (error as ApiException | null)?.type === 'NOT_FOUND'
    ? 'No billing account yet — subscribe a vessel first.'
    : 'Could not open the billing portal. Please try again.';

/** The page's own way into Stripe's billing portal — payment methods, invoices, receipts. */
export function PortalButton() {
  const { data: user } = useMeQuery();
  const portal = useBillingPortal(user?.services?.[0]?.serviceId);

  return (
    <div className={s.portalAction}>
      <button
        type="button"
        className={s.portalBtn}
        onClick={portal.open}
        disabled={!portal.canOpen}
      >
        <FiExternalLink />
        <span>{portal.isRedirecting ? 'Preparing…' : 'Manage payment information'}</span>
      </button>

      {portal.isError && <p className={s.portalError}>{errorMessage(portal.error)}</p>}
    </div>
  );
}
